
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"3","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.977 2.21A4.482 4.482 0 012.03.68 2.193 2.193 0 013.586.062c.625 0 1.37.274 2.234.82.865.548 1.521.821 1.97.821.442 0 .812-.117 1.108-.351.297-.235.597-.6.899-1.094l.625.422c-.224.463-.578.932-1.063 1.406-.484.469-1.073.703-1.765.703-.667 0-1.43-.273-2.29-.82-.853-.547-1.507-.82-1.96-.82-.38 0-.714.12-1 .359-.287.24-.54.588-.758 1.047l-.61-.344z","fill":"currentColor"}})])
          )
        }
      }
    